<template>
  <DefaultTemplate :full-content-width="fullWidth">
    <template #logo>
      <RouterLink to="/">
        <LogoComponent
          app-variant="pool-live"
        />
      </RouterLink>
    </template>
    <template #menu>
      <template v-if="loggedIn">
        <BtnComponent :to="{ name: 'UnitList' }">
          <template #prepend><Icon icon="aip-list" size="1.1rem" /></template>
          {{ $t('template.listOfDevices') }}
        </BtnComponent>
        <div class="spacer" />
        <slot name="menu-prepend" />
        <DialogComponent>
          <template #activator="{ toggle }">
            <BtnComponent @click="toggle">
              <template #prepend><Icon icon="aip-plus" size="1.1rem" /></template>
              {{ $t('template.addDevice') }}
            </BtnComponent>
          </template>
          <template #default="{ toggle }">
            <AddUnitView @on-cancel="toggle" @on-completed="() => { toggle(); $emit('unitAdded') }" />
          </template>
        </DialogComponent>
        <DialogComponent>
          <template #activator="{ toggle }">
            <BtnComponent @click="toggle">
              <template #prepend><Icon icon="aip-account" size="1.1rem" /></template>
              {{ $t('template.profile') }}
            </BtnComponent>
          </template>
          <template #default="{ toggle }">
            <UserAccountView @on-done="toggle" />
          </template>
        </DialogComponent>
      </template>
      <template v-else>
        <div class="spacer" />
        <BtnComponent :to="{ name: 'Login' }">
          {{ $t('common.login') }}
        </BtnComponent>
      </template>
    </template>
    <slot />
  </DefaultTemplate>
</template>
<script>
import DefaultTemplate from '@acs/components-library/src/components/template/DefaultTemplate.vue';
import LogoComponent from '@acs/components-library/src/components/common/Logo.vue';
import Icon from '@acs/components-library/src/components/common/Icon.vue';
import BtnComponent from '@acs/components-library/src/components/common/Btn.vue';
import DialogComponent from '@acs/components-library/src/components/common/Dialog.vue';
import UserAccountView from '../views/UserAccountView.vue';
import AddUnitView from '../views/AddUnitView.vue';
import { isUserLoggedIn } from '@acs/components-library/src/auth.js';

export default {
  components: {
    DefaultTemplate,
    AddUnitView,
    UserAccountView,
    DialogComponent,
    BtnComponent,
    LogoComponent,
    Icon,
  },
  props: {
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['unitAdded', 'goToProfile'],
  setup() {
    const loggedIn = isUserLoggedIn();
    return { loggedIn };
  },
  data() {
    return {
      showMenu: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@use '@acs/components-library/src/assets/styles/variables/sizes.scss';

.spacer {
  display: none;
}

@media (min-width: sizes.$tablet) {
  .spacer {
    display: block;
    flex-grow: 1000;
  }
}
</style>
